export const columns = [
  {
    accessorKey: "name",
    header: "Name",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "weight",
    header: "Weight",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "fixedCharges",
    header: "Fixed Charges",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "demurrageCharges",
    header: "Demurrage Charges",
    type: "string",
    size: 220,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
